import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Dialog as PrimeDialog, DialogProps } from 'primereact/dialog';
import { useFullscreenDialogParent } from '../../general/use-fullscreen-dialog-parent';

export type DialogHandle = PrimeDialog;

/** Keep every dialog portal inside fullscreen, except the dialog that owns it. */
export const Dialog = forwardRef<PrimeDialog, DialogProps>((props, ref) => {
    const dialog = useRef<PrimeDialog>(null);
    useImperativeHandle(ref, () => dialog.current!);
    const suppliedParent = typeof props.appendTo === 'function' ? props.appendTo()
        : props.appendTo === 'self' ? undefined : props.appendTo;
    const parent = useFullscreenDialogParent(suppliedParent);
    const element = dialog.current?.getElement?.();
    // Reparenting an owning dialog into its own fullscreen descendant would
    // create a DOM cycle and remove the element that the browser made fullscreen.
    const ownsFullscreen = Boolean(parent && element?.contains(parent));
    const appendTo = ownsFullscreen ? props.appendTo ?? document.body
        : parent ?? (props.appendTo === 'self' ? 'self' : document.body);
    return <PrimeDialog {...props} ref={dialog} appendTo={appendTo} />;
});
Dialog.displayName = 'Dialog';
